import { useEffect, useState } from 'react';
import {
  ButtonPseudo,
  ButtonSecondary,
  IconDownload,
  IconExpand,
  SelectItemProps,
  Tabs,
} from '@ui/src';
import { useAppSelector } from '@store';
import Hint from '../../common/hint/hint';
import { HeaderTypes } from './types';

import cn from './styles.module.css';

const Header = ({
  onClickAdd,
  onClickExport,
  activeTab,
  setActiveTab,
}: HeaderTypes): React.JSX.Element => {
  const {
    administrationDictionaries: { roles },
  } = useAppSelector((state) => state);

  const [roleOptions, setRoleOptions] = useState<SelectItemProps[]>();

  useEffect(() => {
    if (roles && !roleOptions) {
      setRoleOptions([
        {
          name: 'All roles',
          value: 'all',
        },
        ...roles,
      ]);
    }
  }, [roles, roleOptions]);

  return (
    <div className={cn.header}>
      <div className={cn.headerTop}>
        <div className={cn.title}>Employees list</div>
        {onClickAdd && (
          <ButtonSecondary
            text="Add user"
            onClick={onClickAdd}
            className={cn.addUserButton}
            icon={<IconExpand />}
            bold
          />
        )}
      </div>
      <div className={cn.tabsWrapper}>
        <div className={cn.tabsContent}>
          <Tabs
            tabs={[
              {
                name: 'Access rights',
                value: 'accessRights',
              },
              {
                name: 'Notification settings',
                value: 'notificationSettings',
              },
            ]}
            activeTab={activeTab}
            onClick={(tab) =>
              setActiveTab(tab as 'accessRights' | 'notificationSettings')
            }
          />
        </div>
        <div className={cn.descriptionWrapper}>
          <div className={cn.description}>
            All users have basic access, regardless of role
          </div>
          <Hint>
            <ul>
              <li>Dashboard view</li>
              <li>Accounts view</li>
              <li>Customers view</li>
              <li>AML & KYC view</li>
              <li>Transactions view</li>
              <li>Cards view</li>
              <li>Reports view</li>
              <li>Banks view</li>
              <li>Fees & Tariffs view</li>
              <li>Administration view</li>
            </ul>
          </Hint>
        </div>
      </div>
      {onClickExport && (
        <div className={cn.headerBottom}>
          <ButtonPseudo
            text="Export PDF"
            onClick={onClickExport}
            icon={<IconDownload />}
            className={`button-white ${cn.exportButtonHidden}`}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
